import { parsePhoneNumberWithError } from "libphonenumber-js";

export const formatPhoneForInput = (phonePrefix, phoneNumber) => {
  if (!phonePrefix && !phoneNumber) return "";

  const prefix = String(phonePrefix || "");
  const number = String(phoneNumber || "");

  if (prefix.startsWith("+")) {
    return `${prefix}${number}`;
  }

  if (/^\+?\d{1,3}$/.test(prefix)) {
    return `+${prefix.replace(/^\+/, "")}${number}`;
  }

  if (prefix.startsWith("0")) {
    return `+58${prefix.slice(1)}${number}`;
  }

  return `+${prefix}${number}`;
};

export const splitPhoneForSubmit = (phone) => {
  if (!phone) {
    return { phonePrefix: "", phoneNumber: "" };
  }

  const parsed = parsePhoneNumberWithError(phone);

  return {
    phonePrefix: `+${parsed.countryCallingCode}`,
    phoneNumber: parsed.nationalNumber,
  };
};

export const applySplitPhoneFields = (data, mappings) => {
  const result = { ...data };

  mappings.forEach(({ sourceField, prefixField, numberField }) => {
    if (result[sourceField]) {
      const { phonePrefix, phoneNumber } = splitPhoneForSubmit(
        result[sourceField]
      );
      result[prefixField] = phonePrefix;
      result[numberField] = phoneNumber;
    }

    delete result[sourceField];
  });

  delete result.countryCode;

  return result;
};

export const applyCasePhoneFields = (data) =>
  applySplitPhoneFields(data, [
    { sourceField: "phone", prefixField: "phonePrefix", numberField: "phoneNumber" },
    {
      sourceField: "contactPhone",
      prefixField: "contactNumberPrefix",
      numberField: "contactNumber",
    },
  ]);
